<section id="foundations-endowments">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>Investing for Catholics Supplemental Charts</h1>
      </div>
    </div>
  </div>
</section>

<section class="section">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <h2>Time Series Construction</h2>
        <app-chart-embed [id]="chartId2"></app-chart-embed>

        <h2>DFA Fund and Index Comparison</h2>
        <app-chart-embed [id]="chartId"></app-chart-embed>
      </div>
    </div>
  </div>
</section>